import emojiSupport from 'detect-emoji-support';
export const canShowFlagEmoji = () => {
    return emojiSupport() && !window.navigator.platform.toLowerCase().includes('win');
};
